import { createFeatureSelector, createSelector } from '@ngrx/store';
import { projectDetailsPONumberState } from './projectDetailsPONumber.state';

export const getprojectDetailsPONumberState = createFeatureSelector<projectDetailsPONumberState>('projectDetailsPONumber');

export const getprojectDetailsPONumber = createSelector(
  getprojectDetailsPONumberState,
  (state) => state.projectDetailsPONumber
);
